import React from 'react';
import { Button } from '@udemy/react-core-components';
import { useUDLink } from '@udemy/ud-data';
export const HeaderAuthButton = ({
  authParams = {},
  ...buttonProps
}) => {
  const udLink = useUDLink();
  buttonProps.componentClass = 'a';
  buttonProps.href = udLink.toAuth({
    ...authParams,
    responseType: 'html'
  });
  return /*#__PURE__*/React.createElement(Button, Object.assign({
    size: "medium"
  }, buttonProps));
};
//# sourceMappingURL=header-auth-button.react-component.js.map